import { CaseHistoryResponseDto, FileDto } from '@bandido/shared/dtos';

type EmailBodies = Pick<
  CaseHistoryResponseDto,
  'noteContent' | 'emailContent' | 'emailOriginalContent' | 'emailOriginalText'
>;

/**
 * El cuerpo "limpio" (sin el hilo citado) que se muestra por defecto.
 * Los mails anteriores a la limpieza de hilos solo tienen `emailContent`.
 */
export const getCleanedEmailContent = (history: EmailBodies): string | undefined =>
  history.emailOriginalContent || history.emailOriginalText || undefined;

/**
 * Hay un mail completo distinto del limpio: la limpieza recortó algo y el
 * agente puede pedir ver el original tal cual llegó.
 */
export const hasFullEmailContent = (history: EmailBodies): boolean => {
  const cleaned = getCleanedEmailContent(history);
  return Boolean(cleaned) && Boolean(history.emailContent) && history.emailContent !== cleaned;
};

/**
 * Cuerpo que se cita al responder y que se muestra por defecto: la nota, o el
 * mail limpio, y el completo solo para mails anteriores a la limpieza. No
 * depende de que el agente esté viendo el mail completo en pantalla.
 */
export const getReplyEmailBody = (history: EmailBodies): string =>
  history.noteContent || getCleanedEmailContent(history) || history.emailContent || '';

/**
 * Adjuntos que vale la pena listar: los que no están ya embebidos en el
 * cuerpo del mail (imágenes pegadas, firmas del hilo citado). Se mira el
 * cuerpo completo porque el limpio puede haber recortado la referencia.
 */
export const filesNotEmbedded = (
  files: FileDto[] | undefined,
  history: Pick<CaseHistoryResponseDto, 'emailContent' | 'emailOriginalContent'>,
): FileDto[] => {
  const body = history.emailContent || history.emailOriginalContent || '';
  return (files ?? []).filter((file) => !(file.url && body.includes(file.url)));
};
